import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const routes = [
  {
    path: "/",
    meta: { keepAlive: true },
    component: () => import("./components/ApplyForm"),
  },
  {
    path: "/apply-form",
    name: 'applyForm',
    meta: { keepAlive: true },
    component: () => import("./components/ApplyForm"),
  },
  {
    path: "/new-apply-form",
    name: 'newApplyForm',
    meta: { keepAlive: true },
    component: () => import("./components/newApplyForm"),
  },
  {
    name: "approveForm",
    path: "/approve-form",
    component: () => import("./components/ApproveForm"),
  },
  {
    path: "/select-copy",
    component: () => import("./components/SelectCopy")
  },
  {
    path: "/property-index",
    component: () => import("./components/PropertyIndex")
  },
  {
    path: "/property-board",
    component: () => import("./components/PropertyBoard")
  },
  {
    path: "/cumulative-list",
    component: () => import("./components/CumulativeList")
  },
  {
    path: "/salary-board",
    component: () => import("./components/SalaryBoard")
  },
  {
    path: "/room-list",
    component: () => import("./components/RoomList")
  },
  {
    path: "/room-detail",
    name: 'RoomDetail',
    component: () => import("./components/RoomDetail")
  },
  {
    path: "/client-list",
    component: () => import("./components/ClientList")
  },
  {
    path: "/client-detail",
    name: 'ClientDetail',
    component: () => import("./components/ClientDetail")
  },
  {
    path: "/copy-list",
    component: () => import("./components/CopyList")
  },
  {
    path: "/copy-detail",
    name: 'CopyDetal',
    component: () => import("./components/CopyDetail")
  },
  {
    path: "/order-list",
    component: () => import("./components/OrderList")
  },
  {
    path: "/order-detail",
    name: 'OrderDetail',
    component: () => import("./components/OrderDetail")
  },
  {
    path: "/service-agreement",
    component: () => import("./components/ServiceAgreement"),
  },
  {
    path: "/privacy-agreement",
    component: () => import("./components/PrivacyAgreement"),
  },
  {
    path: "/daily",
    component: () => import("./components/Daily")
  },
  {
    path: "/daily-edit",
    component: () => import("./components/DailyEdit")
  },
  {
    path: "/daily-detail/:id",
    component: () => import("./components/DailyDetails"),
  },
  {
    path: '/month-report',
    component: () => import("./components/MonthReport"),
  },
  {
    path: '/month-report-edit',
    component: () => import("./components/MonthReportEdit"),
  },
  {
    path: '/month-report-detail/:id',
    component: () => import("./components/MonthReportDetail"),
  },
  {
    path: '/copy-table',
    component: () => import("./components/CopyTable"),
  },
  {
    path: '/select-addressbook',
    component: () => import("./commonComponents/SelectAddressBook")
  },
  {
    path: '/map-view',
    component: () => import("./components/MapView"),
  },
  {
    path: '/map-review',
    component: () => import("./components/MapreView"),
  },
  {
    path: '/vue-esign',
    component: () => import("./components/Autograph")
  },
  {
    path: '/pay-slip',
    component: () => import("./components/PaySlip")
  },
  {
    path: '/pay-list',
    component: () => import("./components/PayList")
  },
  {
    path: '/link-detail',
    component: () => import('./components/LinkDetail')
  },
  {
    path: '/workReport',
    meta: { keepAlive: true },
    component: () => import('./components/WorkReport')
  },
  {
    path: '/daily-overview',
    component: () => import('./components/DailyOverview'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/daily-month',
    component: () => import('./components/DailyMonth')
  },
  {
    path: '/daily-trend',
    component: () => import('./components/DailyTrend')
  },
  {
    path: '/daily-submit',
    component: () => import('./components/DailySubmit')
  },
  {
    path: '/daily-rate',
    component: () => import('./components/DailyRate')
  },
  {
    path: '/personal-report-board',
    component: () => import('./components/PersonalReportBoard'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/report-overview',
    component: () => import('./components/ReportOverview'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/report-detail',
    component: () => import('./components/ReportDetail')
  },
  {
    path: '/report-flow-list',
    component: () => import('./components/ReportFlowList')
  },
  {
    path: '/report-trend-manage',
    component: () => import('./components/ReportingTrendManage')
  },
  {
    path: '/report-manage-submit',
    component: () => import('./components/ReportManageSubmit')
  },
  {
    path: '/select-data-range',
    component: () => import('./components/SelectDataRange')
  },
  {
    path: '/user-count-list',
    component: () => import('./components/UserCountList')
  },
  {
    path: '/personnel-selection',
    component: () => import('./components/personnelSelection/index'),
    redirect: '/personnel-selection/company-list',
    children: [
      {
        path: 'company-list',
        component: () => import('./components/personnelSelection/components/companyList')
      },
      {
        path: 'department-list',
        name: 'departmentList',
        component: () => import('./components/personnelSelection/components/departmentList')
      },
      {
        path: 'search-list',
        name: 'searchList',
        component: () => import('./components/personnelSelection/components/searchList')
      }
    ]
  },
  {
    path: '/new-personnel-selection',
    component: () => import('./components/newPersonnelSelection/index'),
    redirect: '/new-personnel-selection/company-list',
    children: [
      {
        path: 'company-list',
        component: () => import('./components/newPersonnelSelection/components/companyList')
      },
      {
        path: 'department-list',
        name: 'newDepartmentList',
        component: () => import('./components/newPersonnelSelection/components/departmentList')
      },
      {
        path: 'search-list',
        name: 'newSearchList',
        component: () => import('./components/newPersonnelSelection/components/searchList')
      }
    ]
  },
  {
    path: '/approval-personnel-selection',
    component: () => import('./components/approvalPersonnelSelection/index'),
    redirect: '/approval-personnel-selection/company-list',
    children: [
      {
        path: 'company-list',
        component: () => import('./components/approvalPersonnelSelection/components/companyList')
      },
      {
        path: 'department-list',
        name: 'newApprovalDepartmentList',
        component: () => import('./components/approvalPersonnelSelection/components/departmentList')
      },
      {
        path: 'search-list',
        name: 'newApprovalSearchList',
        component: () => import('./components/approvalPersonnelSelection/components/searchList')
      }
    ]
  },
  {
    path: '/bills',
    component: () => import('./components/Bills')
  },
  {
    path: '/draft', //费控草稿箱
    component: () => import('./components/draft')
  },
  {
    path: '/financialDaily', //费控草稿箱
    component: () => import('./components/financial/financialDaily')
  },
  {
    name: "approveFormOldPg",
    path: "/approve-form-old-pg",
    component: () => import("./components/ApproveFormOldInstanceIdPage"),
  },
];
export const router = new Router({
  routes,
});
